import type { PublishedProjectVersionItem } from '@/features/published-project/api'
import type { PublishedMapEntry } from '@/features/published-project/mapManifest'

export interface PublishedProjectVersion3Item extends PublishedProjectVersionItem {
  mapEntries?: PublishedMapEntry[]
}

/** 构建已发布版本工程主包候选 OSS 路径。 */
export function buildPublishedProjectMainBinCandidates(guid: string, version: string): string[] {
  const cleanGuid = guid.trim()
  const cleanVersion = String(version || '').trim()
  return [`${cleanGuid}/other/ProjectS${cleanVersion}.bin`]
}

function toTime(value: string): number {
  const direct = Number(value)
  if (Number.isFinite(direct) && direct > 0) {
    return direct > 1e12 ? direct : direct * 1000
  }
  const parsed = Date.parse(value)
  return Number.isNaN(parsed) ? 0 : parsed
}

/** 按发布时间倒序排列版本列表。 */
export function sortPublishedVersions(versions: PublishedProjectVersionItem[]): PublishedProjectVersionItem[] {
  return versions.slice().sort((a, b) => {
    const timeDiff = toTime(b.createTime) - toTime(a.createTime)
    if (timeDiff !== 0) return timeDiff
    return Number(b.version) - Number(a.version)
  })
}
